// extracted by mini-css-extract-plugin
export default {"title":"style_title__-zEwh","list":"style_list__TPFsN","tv_show_list_item":"style_tv_show_list_item__UqUZy"};